export class Viproc {
  viprocNumero: number
  viprocAno: number

  constructor(number: number, year: number) {
    this.viprocNumero = number
    this.viprocAno = year
  }
}
